import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CoreModule } from '@core/core.module';
// import { CoreComponents } from '@core/components/core.components';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';
import { PipesModule } from '@core/pipes/pipes.module'

import { CoreCustomFormsFieldHelpersModule } from './helpers/custom-forms-field-helpers.module';
import { CoreCustomFormsFieldComponentsModule } from './fields/field-components.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // CoreComponents,
        // HelpersModule,
        // LabelsModule,
        // HelpersEditorModule,
        // PipesModule,
        CoreCustomFormsFieldHelpersModule,
        CoreCustomFormsFieldComponentsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
    ],
    exports: [
        CoreCustomFormsFieldComponentsModule,
        CoreCustomFormsFieldHelpersModule
    ],

})
export class CoreCustomFormsModule { }
